import React from 'react';

import PropTypes from 'prop-types';
import { Label } from 'semantic-ui-react';

import './MarkdownHighlightingKey.scss';

const propTypes = {
  showKeyword: PropTypes.bool,
};

const defaultProps = {
  showKeyword: false,
};

export default function MarkdownHighlightingKey({ showKeyword }) {
  return (
    <div className="markdown-highlighting-key">
      <Label className="additional-highlight">Addition</Label>
      <Label className="removal-highlight">Removal</Label>
      {showKeyword && <Label className="keyword-highlight">Keyword</Label>}
    </div>
  );
}

MarkdownHighlightingKey.propTypes = propTypes;
MarkdownHighlightingKey.defaultProps = defaultProps;
